<template lang="pug">
    div(v-if="delayBeforeShowEstimate" style="border:0px solid;")
        div(:style="userId === 0 ? 'height:calc(100vh - 215px); border-radius:5px 5px 0 0; border-color:black; border-style:solid; border-width:1px 1px 0 1px;' : 'height:645px; border-radius:5px; border:0px solid;'" style="position:relative; overflow-y:scroll; overflow-x:hidden;background-color:#fff")
            div(style="float:left; width:210px; border:0px solid;")
                div(class="yellow2 text-left" style="height:35px; padding-top:6px; border:0px solid;")
                    span(class="ml-2" style="font-size:16px; border:0px solid;") Latest Price
                    span(class="ml-2" style="font-size:16px; font-weight:600; border:0px solid;") {{ thousandFormatter(stock.price_today) }}
                    span(class="ml-2" style="font-size:16px; font-weight:600; border:0px solid;") {{ stock.currency_trade }}
                div(class="pl-2" style="position:absolute; font-size:14px; top:35px; border:0px solid;") {{ $t('estimations') }}
                div(style="height:22px; border:0px solid;")
                div(style="height:574px; border-right:1.5px solid; border-bottom:0.7px solid #A3B3C2;")
                    div(class="text-right pr-2" style="margin-top:12px; height:22px; border:0px solid;") {{ getUserActualsQ_or_Fy.period }}

                    div(style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('Sales') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.sales)") {{ thousandFormatter(getUserActualsQ_or_Fy.sales) }}

                    div(style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('Sales_growth_percent') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="`${getUserActualsQ_or_Fy.sales_growth}%`") {{ getUserActualsQ_or_Fy.sales_growth }}%

                    div(style="height:22px; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('ebit') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.ebit)") {{ thousandFormatter(getUserActualsQ_or_Fy.ebit) }}

                    div(style="height:22px; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('ebit_growth_percent') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="`${getUserActualsQ_or_Fy.ebit_growth}%`") {{ getUserActualsQ_or_Fy.ebit_growth }}%

                    div(style="height:22px; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('ebit_margin_percent') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="`${getUserActualsQ_or_Fy.ebit_margin}%`") {{ getUserActualsQ_or_Fy.ebit_margin }}%

                    div(style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('Profit') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.profit)") {{ thousandFormatter(getUserActualsQ_or_Fy.profit) }}

                    div(style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('Profit_growth_percent') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="`${getUserActualsQ_or_Fy.profit_growth}%`") {{ getUserActualsQ_or_Fy.profit_growth }}%

                    div(style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('Profit_margin_percent') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="`${getUserActualsQ_or_Fy.profit_margin}%`") {{ getUserActualsQ_or_Fy.profit_margin }}%

                    div(style="height:22px; border-top:0.7px solid #A3B3C2; border-bottom:0.7px solid #A3B3C2;")
                        div(class="pl-2" style="white-space:nowrap; height:22px; float:left; width:55%; border:0px solid;") {{ $t('eps') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.eps)") {{ thousandFormatter(getUserActualsQ_or_Fy.eps) }}

                    div(class="mt-5 pl-2" style="font-size:14px; border:0px solid;") {{ $t('valuation_multiplier') }}
                    div(class="pl-2" style="height:22px; border-top:0.7px solid #A3B3C2;")
                        div(style="float:left; white-space:nowrap; width:55%; border:0px solid;")
                            div(style="display:inline-block; border:0px solid;") {{ $t('P_E') }}
                            div(style="display:inline-block; border:0px solid;")
                                div(style="position:relative")
                                    input(@click="selectRadioButton('pe')" type="radio" :checked="selectedRadioButtons.pe" style="position:absolute; top:-10px; left:10px; transform:scale(0.85);")
                        div(class="text-right pr-2" style="float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.pe)") {{ thousandFormatter(getUserActualsQ_or_Fy.pe) }}
                    
                    div(class="pl-2" style="height:22px; border-top:0.7px solid #A3B3C2;  border-bottom:0.7px solid #A3B3C2;")
                        div(style="float:left; white-space:nowrap; width:55%; border:0px solid;")
                            div(style="display:inline-block; border:0px solid;") {{ $t('P_S') }}
                            div(style="display:inline-block; border:0px solid;")
                                div(style="position:relative")
                                    input(@click="selectRadioButton('ps')" type="radio" :checked="selectedRadioButtons.ps" style="position:absolute; top:-10px; left:10px; transform:scale(0.85);")
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.ps)") {{ thousandFormatter(getUserActualsQ_or_Fy.ps) }}

                    div(class="mt-5 pl-2" style="height:22px; border-top:0.7px solid #A3B3C2;  border-bottom:0.7px solid #A3B3C2;")
                        div(style="height:22px; float:left; white-space:nowrap; width:55%; border:0px solid;") {{ $t('Price') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.price)") {{ thousandFormatter(getUserActualsQ_or_Fy.price) }}

                    div(class="text-right" style="height:22px; color:lightgrey;") {{ getUserActualsQ_or_Fy.date_report }}

                    div(class="mt-2 pl-2" style="height:22px; border-top:0.7px solid #A3B3C2;")
                        div(style="height:22px; float:left; white-space:nowrap; width:55%; border:0px solid;") {{ $t('EV_EBIT') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.ev_ebit)") {{ thousandFormatter(getUserActualsQ_or_Fy.ev_ebit) }}

                    div(class="pl-2" style="height:22px; border-top:0.7px solid #A3B3C2;")
                        div(style="height:22px; float:left; white-space:nowrap; width:55%; border:0px solid;") {{ $t('number_of_shares') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(getUserActualsQ_or_Fy.totalnumberofshares)") {{ thousandFormatter(getUserActualsQ_or_Fy.totalnumberofshares) }}

                    div(class="pl-2" style="height:22px; border-top:0.7px solid #A3B3C2;")
                        div(style="height:22px; float:left; white-space:nowrap; width:55%; border:0px solid;") {{ $t('Market_cap') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;" :title="thousandFormatter(Number(getUserActualsQ_or_Fy.totalnumberofshares) * Number(getUserActualsQ_or_Fy.price))") {{ thousandFormatter(Number(getUserActualsQ_or_Fy.totalnumberofshares) * Number(getUserActualsQ_or_Fy.price)) }}

                    div(class="pl-2" style="height:22px; border-top:0.7px solid #A3B3C2; border-bottom:0.7px solid #A3B3C2;")
                        div(style="height:22px; float:left; white-space:nowrap; width:55%; border:0px solid;") {{ $t('upside') }}
                        div(class="text-right pr-2" style="height:22px; float:left; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; width:45%; border:0px solid;") 

            div(id="estimatesRightContainer" style="float:left; width:365px; border:0px solid;")
                div(class="yellow2" style="height:35px; font-size:12px; font-weight:600;")
                    div(class="text-right pr-1" style="float:left; height:35px; width:100%; padding-top:5px; border:0px solid;")
                        button(@click="changeQOrFy('FY')" class="left-menu-button" :class="Q_or_FY === 'FY' ? 'menu-button-active' : ''") Annual
                        button(@click="changeQOrFy('Q')" class="right-menu-button" :class="Q_or_FY === 'Q' ? 'menu-button-active' : ''") Quaterly

                //- div(style="position:relative; border:0px solid;")
                    hr(style="position:absolute; width:calc(100% + 240px); left:-235px; top:-11px; height:0.8px; background-color:black; border:none;")

                //- Estimates
                div(class="estimates-placeholder pb-4" style="width:360px; overflow-x:scroll; padding-top:5px; border:0px solid red;")
                    div(:style="`width:${widthForEstimationArea}px;`" style="border:0px solid green;")
                        div(v-for="(quarter, i) in estimationData" class="text-right pt-2" style="float:left; width:120px; border:0px solid;")
                            div(class="pr-2" style="height:16px; margin-top:6px; border-bottom:0px solid;") {{ $t('estimate') }}
                            div(class="pr-2" style="height:22px;") {{ quarter.period }}
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.sales ? 'flash-from-grey-to-yellow' : null" style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;" :style="(pinkMarker.period === quarter.period && pinkMarker.section === 'sales' && (quarter.sales === '' || quarter.sales === null)) ? 'background-color:#f2e5e9;' : null")
                                input(@blur="setShowBlur(`sales${i}`, `salesNote${i}`, 'sales', quarter.period, false)" @keyup.enter="setShow(`sales${i}`, `salesNote${i}`, false), setSalesGrowth(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.sales" type="text" :id="`sales${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`sales${i}`, `salesNote${i}`, true), selectInput(`sales${i}`), originalString = quarter.sales" :id="`salesNote${i}`" style="width:100%; height:22px; display:block; border:0px solid;") {{ thousandFormatter(quarter.sales) !== 0 ? thousandFormatter(quarter.sales) : null }}
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.sales_growth ? 'flash-from-grey-to-yellow' : null" style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;" :style="(pinkMarker.period === quarter.period && pinkMarker.section === 'sales' && (quarter.sales_growth === '' || quarter.sales_growth === null)) ? 'background-color:#f2e5e9;' : null")
                                input(@blur="setShowBlur(`salesGrowth${i}`, `salesGrowthNote${i}`, 'sales_growth', quarter.period, false)" @keyup.enter="setShow(`salesGrowth${i}`, `salesGrowthNote${i}`, false), setSales(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.sales_growth" type="text" :id="`salesGrowth${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`salesGrowth${i}`, `salesGrowthNote${i}`, true), selectInput(`salesGrowth${i}`), originalString = quarter.sales_growth" :id="`salesGrowthNote${i}`" style="display:block; width:100%; height:100%; border:0px solid;")
                                    span {{ quarter.sales_growth }}
                                    span(v-if="quarter.sales_growth !== null") %
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.ebit ? 'flash-from-white-to-yellow' : null" style="height:22px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;")
                                input(@blur="setShowBlur(`ebit${i}`, `ebitNote${i}`, 'ebit', quarter.period, false)" @keyup.enter="setShow(`ebit${i}`, `ebitNote${i}`, false), setEbitGrowthMargin(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.ebit" type="text" :id="`ebit${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`ebit${i}`, `ebitNote${i}`, true), selectInput(`ebit${i}`), originalString = quarter.ebit" :id="`ebitNote${i}`" style="width:100%; height:22px; display:block; border:0px solid;") {{ thousandFormatter(quarter.ebit) !== 0 ? thousandFormatter(quarter.ebit) : null }}
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.ebit_growth ? 'flash-from-white-to-yellow' : null" style="height:22px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;")
                                input(@blur="setShowBlur(`ebitGrowth${i}`, `ebitGrowthNote${i}`, 'ebit_growth', quarter.period, false)" @keyup.enter="setShow(`ebitGrowth${i}`, `ebitGrowthNote${i}`, false), setEbitMargin(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.ebit_growth" type="text" :id="`ebitGrowth${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`ebitGrowth${i}`, `ebitGrowthNote${i}`, true), selectInput(`ebitGrowth${i}`), originalString = quarter.ebit_growth" :id="`ebitGrowthNote${i}`" style="display:block; width:100%; height:100%; border:0px solid;")
                                    span {{ quarter.ebit_growth }}
                                    span(v-if="quarter.ebit_growth !== null") %
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.ebit_margin ? 'flash-from-white-to-yellow' : null" style="height:22px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;")
                                input(@blur="setShowBlur(`ebitMargin${i}`, `ebitMarginNote${i}`, 'ebit_margin', quarter.period, false)" @keyup.enter="setShow(`ebitMargin${i}`, `ebitMarginNote${i}`, false), setEbitGrowth(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.ebit_margin" type="text" :id="`ebitMargin${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`ebitMargin${i}`, `ebitMarginNote${i}`, true), selectInput(`ebitMargin${i}`), originalString = quarter.ebit_margin" :id="`ebitMarginNote${i}`" style="display:block; width:100%; height:100%; border:0px solid;")
                                    span {{ quarter.ebit_margin }}
                                    span(v-if="quarter.ebit_margin !== null") %
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.profit ? 'flash-from-grey-to-yellow' : null" style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;" :style="(pinkMarker.period === quarter.period && pinkMarker.section === 'profit' && (quarter.profit === '' || quarter.profit === null)) ? 'background-color:#f2e5e9;' : null")
                                input(@blur="setShowBlur(`profit${i}`, `profitNote${i}`, 'profit', quarter.period, false)" @keyup.enter="setShow(`profit${i}`, `profitNote${i}`, false), setProfitGrowthMarginEps(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.profit" type="text" :id="`profit${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`profit${i}`, `profitNote${i}`, true), selectInput(`profit${i}`), originalString = quarter.profit" :id="`profitNote${i}`" style="width:100%; height:22px; display:block; border:0px solid;") {{ thousandFormatter(quarter.profit) !== 0 ? thousandFormatter(quarter.profit) : null }}
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.profit_growth ? 'flash-from-grey-to-yellow' : null" style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;" :style="(pinkMarker.period === quarter.period && pinkMarker.section === 'profit' && (quarter.profit_growth === '' || quarter.profit_growth === null)) ? 'background-color:#f2e5e9;' : null")
                                input(@blur="setShowBlur(`profitGrowth${i}`, `profitGrowthNote${i}`, 'profit_growth', quarter.period, false)" @keyup.enter="setShow(`profitGrowth${i}`, `profitGrowthNote${i}`, false), setProfitMarginEps(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.profit_growth" type="text" :id="`profitGrowth${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`profitGrowth${i}`, `profitGrowthNote${i}`, true), selectInput(`profitGrowth${i}`), originalString = quarter.profit_growth" :id="`profitGrowthNote${i}`" style="display:block; width:100%; height:100%; border:0px solid;")
                                    span {{ quarter.profit_growth }}
                                    span(v-if="quarter.profit_growth !== null") %
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.profit_margin ? 'flash-from-grey-to-yellow' : null" style="height:22px; background-color:#f6f6f6; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;" :style="(pinkMarker.period === quarter.period && pinkMarker.section === 'profit' && (quarter.profit_margin === '' || (quarter.profit_margin === null && quarter.profit === null))) ? 'background-color:#f2e5e9;' : null")
                                input(@blur="setShowBlur(`profitMargin${i}`, `profitMarginNote${i}`, 'profit_margin', quarter.period, false)" @keyup.enter="setShow(`profitMargin${i}`, `profitMarginNote${i}`, false), setProfitGrowthEps(quarter, getUserActualsQ_or_Fy, getBase(quarter.period))" v-model="quarter.profit_margin" type="text" :id="`profitMargin${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`profitMargin${i}`, `profitMarginNote${i}`, true), selectInput(`profitMargin${i}`), originalString = quarter.profit_margin" :id="`profitMarginNote${i}`" style="display:block; width:100%; height:100%; border:0px solid;")
                                    span {{ quarter.profit_margin }}
                                    span(v-if="quarter.profit_margin !== null") %
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.eps ? 'flash-from-white-to-yellow' : null" style="height:22px; border-top:0.7px solid #A3B3C2; border-bottom:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;") {{ quarter.eps }}
                            div(style="padding-top:41px; border-top:0px solid black !important; border-bottom:0px solid black !important; border-left:0px solid black !important; border-right:0.7px solid #A3B3C2 !important;")
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.pe ? 'flash-from-white-to-yellow' : null" :style="selectedRadioButtons.ps ? 'color:lightgrey' : ''" style="height:22px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;")
                                input(@blur="setShowBlur(`pe${i}`, `peNote${i}`, 'pe', quarter.period, false), checkIfNeededSectionIsEmpty({ period: 'none', section: 'none' })" @keyup.enter="setShow(`pe${i}`, `peNote${i}`, false), setPs(quarter, getUserActualsQ_or_Fy)" v-model="quarter.pe" type="text" :id="`pe${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`pe${i}`, `peNote${i}`, true), selectInput(`pe${i}`), checkIfNeededSectionIsEmpty({ period: quarter.period, section: 'profit' }), originalString = quarter.pe" :id="`peNote${i}`" style="width:100%; height:22px; display:block; border:0px solid;") {{ thousandFormatter(quarter.pe) !== 0 ? thousandFormatter(quarter.pe) : null }}
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.ps ? 'flash-from-white-to-yellow' : null" :style="selectedRadioButtons.pe ? 'color:lightgrey' : ''" style="height:21px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;")
                                input(@blur="setShowBlur(`ps${i}`, `psNote${i}`, 'ps', quarter.period, false), checkIfNeededSectionIsEmpty({ period: 'none', section: 'none' })" @keyup.enter="setShow(`ps${i}`, `psNote${i}`, false), setPe(quarter, getUserActualsQ_or_Fy)" v-model="quarter.ps" type="text" :id="`ps${i}`" class="text-right" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`ps${i}`, `psNote${i}`, true), selectInput(`ps${i}`), checkIfNeededSectionIsEmpty({ period: quarter.period, section: 'sales' }), originalString = quarter.ps" :id="`psNote${i}`" style="width:100%; height:22px; display:block; border:0px solid;") {{ thousandFormatter(quarter.ps) !== 0 ? thousandFormatter(quarter.ps) : null }}
                            div(style="height:44px;")
                                div(class="pr-2" style="height:21px; color:lightgrey; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;")
                                    div(v-if="quarter.target_price !== null" style="margin-top:5px;") target
                                div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.price ? 'flash-from-white-to-yellow' : null" style="height:22px; font-size:15px; font-weight:600; border-top:0.7px solid #A3B3C2; border-bottom:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;" :style="(pinkMarker.period === quarter.period && (pinkMarker.section === 'profit' || pinkMarker.section === 'sales') && (quarter.target_price === '' || quarter.target_price === null)) ? 'background-color:#f2e5e9;' : null") {{ thousandFormatter(quarter.target_price) !== 0 ? thousandFormatter(quarter.target_price) : null }}
                            div(style="padding-top:29px; border-top:0px solid black !important; border-bottom:0px solid black !important; border-left:0px solid black !important; border-right:0.7px solid #A3B3C2 !important;")
                            div(class="pr-2" style="height:22px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;") {{ thousandFormatter(quarter.ev_ebit) !== 0 ? thousandFormatter(quarter.ev_ebit) : null }}
                            div(class="pr-2" style="height:22px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;") {{ thousandFormatter(quarter.totalnumberofshares) !== 0 ? thousandFormatter(quarter.totalnumberofshares) : null }}
                            div(class="pr-2" style="height:22px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;") {{ (quarter.totalnumberofshares * quarter.target_price) !== 0 ? thousandFormatter((quarter.totalnumberofshares * quarter.target_price).toFixed(0)) : null }}
                            div(class="pr-2" :class="flashObject.period === quarter.period && flashObject.upside ? 'flash-from-white-to-yellow' : null" style="height:21px; border-top:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;" :style="upside(stock.price_today, quarter.target_price) >= 0 ? 'color:green;' : 'color:red;'") {{ quarter.target_price !== null ? `${upside(stock.price_today, quarter.target_price)}%` : null }}
                            div(class="text-left pl-2 pr-2" :class="flashObject.period === quarter.period && flashObject.note ? 'flash-from-white-to-yellow' : null" style="height:110px; overflow-y:scroll; overflow-x:hidden; border-top:0.7px solid #A3B3C2; border-bottom:0.7px solid #A3B3C2; border-right:0.7px solid #A3B3C2;")
                                textarea(@blur="setShowBlur(`comment${i}`, `commentNote${i}`, 'note', quarter.period, false)" @keyup.enter="setShow(`comment${i}`, `commentNote${i}`, false), setComment(quarter, getUserActualsQ_or_Fy)" v-model="quarter.note" type="text" :id="`comment${i}`" style="display:none; width:100%; height:100%; border:1px solid;")
                                div(@click="setShow(`comment${i}`, `commentNote${i}`, true), selectInput(`comment${i}`), originalString = quarter.note" :id="`commentNote${i}`" style="width:100%; height:100%; display:block; border:0px solid;") {{ quarter.note }}

        div(v-if="userId === 0" class="text-center" style="font-size:15px; color:#686868; height:25px; background-color:#F4C47C; border-radius:0 0 5px 5px; border:0px solid;") Signup with your email to save data

        div(class="mt-3" style="height:40px; border:0px solid;")
            div(style="float:left; width:50%; height:40px; border:0px solid;")
                v-btn(@click="clearAll()" elevation="0" class="btn-primary" style="") Clear all
            div(class="text-right" style="float:left; width:50%; height:40px; border:0px solid;")
                div(v-if="saveStates === ''")
                div(v-else-if="saveStates === 'saving'" style="font-size:17px; color:#636161; height:30px; border:0px solid;")
                    v-icon(size="25" class="rotate-icon mr-2" style="display:inline-block; height:30px; border:0px solid;") mdi-sync
                    div(style="display:inline-block; height:30px; border:0px solid;") Saving...
                div(v-else-if="saveStates === 'saved'" style="font-size:17px; color:#636161; height:30px; border:0px solid;")
                    v-icon(size="25" class="mr-2" style="display:inline-block; height:34px; border:0px solid;") $saved
                    div(style="display:inline-block; height:30px; border:0px solid;") Saved
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import _ from 'lodash';

const helper = require('./../util/helper');

export default {
    name: 'Estimates',
    props: {
        target: String
    },
    data() {
        return {
            // Just some dummy data to setup functionality
            // if the user is just a visitor or real user
            delayBeforeShowEstimate: false,
            userId: 1,
            saveStates: '',
            windowHeight: 0,
            selectedRadioButtons: {
                pe: true,
                ps: false
            },
            quaterlyLookup: [
                '2021-Q1',
                '2021-Q2',
                '2021-Q3',
                '2021-Q4',
                '2022-Q1',
                '2022-Q2',
                '2022-Q3',
                '2022-Q4',
                '2023-Q1',
                '2023-Q2',
                '2023-Q3',
                '2023-Q4'
            ],
            annualLookup: [
                '2021',
                '2022',
                '2023',
                '2024',
                '2025',
            ],
            Q_or_FY: 'Q',
            estimationData: [],
            originalString: null,
            pinkMarker: {
                period: 'none',
                section: false
            },
            flashObject: {
                period: 'none',
                sales: false,
                sales_growth: false,
                ebit: false,
                ebit_growth: false,
                ebit_margin: false,
                profit: false,
                profit_growth: false,
                profit_margin: false,
                eps: false,
                pe: false,
                ps: false,
                price: false,
                upside: false,
                note: false
            }
        };
    },
    async mounted() {
        this.windowHeight = window.innerHeight;

        if(this.target !== '') {
            window.addEventListener('resize', this.windowResizeHeight);
        }

        await Promise.all([
            this.loadCompanyActuals(this.company_id),
            this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            })
        ]);

        this.estimationData = this.buildEstimationData();

        this.delayBeforeShowEstimate = true;

        // console.log(JSON.parse(JSON.stringify(this.getUserActualsQ_or_Fy)));
        // console.log(JSON.parse(JSON.stringify(this.getUserEtimates)));

        // console.log(this.widthForEstimationArea);
        // console.log(this.highestActualPeriod);
        // console.log(JSON.parse(JSON.stringify(this.estimationData)));
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.windowResizeHeight);
    },
    watch: {
        async stock_id() {
            await Promise.all([
                this.loadCompanyActuals(this.company_id),
                this.loadUserCompanyEstimates({
                    user_id: this.user_id,
                    company_id: this.company_id,
                })
            ]);

            this.estimationData = this.buildEstimationData();
        },
        target() {
            if(this.target !== 'estimate') {
                window.removeEventListener('resize', this.windowResizeHeight);
            } else {
                this.windowHeight = window.innerHeight;
                window.addEventListener('resize', this.windowResizeHeight);
            }
        }
    },
    computed: {
        ...mapGetters([
            'getAllStocks',
            'getUserCompanyEstimates',
            'getUserActuals',
            'getUserEtimates'
        ]),
        user_id() {
            return JSON.parse(localStorage.getItem('user')).user_id;
        },
        stock_id() {
            return parseInt(this.$route.params.stock_id);
        },
        company_id() {
            return this.getAllStocks.find((s) => s.stock_id === this.stock_id).company_id;
        },
        stock() {
            return this.getAllStocks.find((s) => s.stock_id === this.stock_id);
        },
        getUserCompanyEstimatesOnCompanyId() {
            return this.getUserCompanyEstimates.filter((e) => e.company_id === this.company_id);
        },
        highestActualPeriod() {
            return this.getUserActuals.find((o) => o.type_report === this.Q_or_FY).period;
        },
        getUserActualsQ_or_Fy() {
            return this.getUserActuals.find((o) => o.type_report === this.Q_or_FY);
        },
        estimationDataToString() {
            return JSON.stringify(this.estimationData);
        },
        widthForEstimationArea() {
            return this.buildEstimationData().length * 120;
        }
    },
    methods: {
        ...mapActions([
            'loadUserCompanyEstimates',
            'loadCompanyActuals',
            'insertEstimate',
            'updateEstimate',
            'deleteEstimatesOnUserIdAndCompanyId'
        ]),
        ...mapMutations([
            'setRegisterType',
            'setRegisterWindows'
        ]),
        async clearAll() {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const deleteObject = {
                user_id: this.user_id,
                company_id: this.company_id
            };

            await this.deleteEstimatesOnUserIdAndCompanyId(deleteObject);

            this.estimationData = this.buildEstimationData();

            this.saveStates = '';
        },
        windowResizeHeight() {
            this.windowHeight = window.innerHeight;
            // console.log(this.windowHeight);
        },
        changeQOrFy(Q_or_FY) {
            this.Q_or_FY = Q_or_FY;

            this.estimationData = this.buildEstimationData();
        },
        thousandFormatter(value) {
            return helper.thousandFormatter(value);
        },
        upside(oldPrice, newPrice) {
            if(newPrice >= (oldPrice + 100)) {
                return (((newPrice - oldPrice) / oldPrice) * 100).toFixed(0);
            } else {
                return -(((oldPrice - newPrice) / oldPrice) * 100).toFixed(0);
            }
        },
        selectRadioButton(option) {
            if(option === 'pe') {
                this.selectedRadioButtons.pe = true;
                this.selectedRadioButtons.ps = false;
            } else {
                this.selectedRadioButtons.pe = false;
                this.selectedRadioButtons.ps = true;
            }
        },
        buildEstimationData() {
            let tempArr = [];
            let lookupUsed = null;

            if(this.Q_or_FY === 'Q') {
                lookupUsed = this.quaterlyLookup.filter((q) => q > this.highestActualPeriod);
            } else if(this.Q_or_FY === 'FY') {
                lookupUsed = this.annualLookup.filter((q) => q > this.highestActualPeriod);
            }

            // console.log(this.highestActualPeriod);
            // console.log(this.quaterlyLookup);
            // console.log(lookupUsed);

            for(const lookup of lookupUsed) {
                tempArr.push({
                    company_id: this.company_id,
                    ebit: null,
                    ebit_growth: null,
                    ebit_margin: null,
                    eps: null,
                    ev_ebit: null,
                    market_cap: null,
                    multiplier: null,
                    note: null,
                    pb: null,
                    pe: null,
                    period: lookup,
                    profit: null,
                    profit_growth: null,
                    profit_margin: null,
                    ps: null,
                    sales: null,
                    sales_growth: null,
                    target_price: null,
                    totalnumberofshares: null,
                    user_company_est_id: null,
                    user_id: this.user_id,
                });
            }

            for(let i = 0; i < tempArr.length; i++) {
                for(let j = 0; j < this.getUserEtimates.length; j++) {
                    if(tempArr[i].period === this.getUserEtimates[j].period) {
                        tempArr[i] =  this.getUserEtimates[j];
                    }
                }
            }

            tempArr = _.orderBy(tempArr, ['period'], ['asc']);

            // console.log(JSON.parse(JSON.stringify(tempArr)));

            return tempArr;
        },
        selectInput(name) {
            const element = document.getElementById(name);

            // console.log(element);

            setTimeout(() => {
                // console.log(element);
                element.focus();
            }, 50);
        },
        async setSalesGrowth(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const salesEstimateTemp = parseFloat(est.sales);
            const salesActualTemp = parseFloat(base.sales);
            const salesGrowthPercent = parseFloat(((salesEstimateTemp - salesActualTemp) / salesActualTemp) * 100);
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.sales_growth = salesGrowthPercent.toFixed(0);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                sales: salesEstimateTemp,
                sales_growth: salesGrowthPercent
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                sales: true,
                sales_growth: true
            });

            this.saveStates = 'saved';
        },
        async setSales(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const salesGrowthEstimateTemp = parseFloat(est.sales_growth);
            const salesActualTemp = parseFloat(base.sales);
            const sales = ((salesGrowthEstimateTemp / 100) + 1) * salesActualTemp;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.sales = sales.toFixed(0);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                sales: parseFloat(sales.toFixed(0)),
                sales_growth: salesGrowthEstimateTemp
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                sales: true,
                sales_growth: true
            });

            this.saveStates = 'saved';
        },
        async setEbitGrowthMargin(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const ebitEstimateTemp = parseFloat(est.ebit);
            const salesEstimateTemp = parseFloat(est.sales);
            const ebitActualTemp = parseFloat(base.ebit);
            const ebitGrowth = ((ebitEstimateTemp - ebitActualTemp) / ebitActualTemp) * 100;
            const ebitMargin = (ebitEstimateTemp / salesEstimateTemp) * 100;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.ebit_growth = ebitGrowth.toFixed(0);
                    estimate.ebit_margin = ebitMargin.toFixed(0);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                ebit: ebitEstimateTemp,
                ebit_growth: ebitGrowth,
                ebit_margin: ebitMargin
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                ebit: true,
                ebit_growth: true,
                ebit_margin: true
            });

            this.saveStates = 'saved';
        },
        async setEbitMargin(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const ebitGrowthEstimateTemp = parseFloat(est.ebit_growth);
            const salesEstimateTemp = parseFloat(est.sales);
            const ebitActualTemp = parseFloat(base.ebit);
            const ebit = ((ebitGrowthEstimateTemp / 100) + 1) * ebitActualTemp;
            const ebitMargin = (ebit / salesEstimateTemp) * 100;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.ebit = ebit.toFixed(0);
                    estimate.ebit_margin = ebitMargin.toFixed(0);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                ebit: ebit,
                ebit_growth: ebitGrowthEstimateTemp,
                ebit_margin: ebitMargin
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                ebit: true,
                ebit_growth: true,
                ebit_margin: true
            });

            this.saveStates = 'saved';
        },
        async setEbitGrowth(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const ebitMarginEstimateTemp = parseFloat(est.ebit_margin);
            const salesEstimateTemp = parseFloat(est.sales);
            const ebitActualTemp = parseFloat(base.ebit);
            const ebit = salesEstimateTemp * (ebitMarginEstimateTemp / 100);
            const ebitGrowth = ((ebit - ebitActualTemp) / ebitActualTemp) * 100;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.ebit = ebit.toFixed(0);
                    estimate.ebit_growth = ebitGrowth.toFixed(0);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                ebit: ebit,
                ebit_growth: ebitGrowth,
                ebit_margin: ebitMarginEstimateTemp
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                ebit: true,
                ebit_growth: true,
                ebit_margin: true
            });

            this.saveStates = 'saved';
        },
        async setProfitGrowthMarginEps(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const profitEstimateTemp = parseFloat(est.profit);
            const salesEstimateTemp = parseFloat(est.sales);
            const totalnumberofsharesEstimateTemp = parseFloat(act.totalnumberofshares);
            const profitActualTemp = parseFloat(base.profit);
            const profitGrowth = ((profitEstimateTemp - profitActualTemp) / profitActualTemp) * 100;
            const profitMargin = (profitEstimateTemp / salesEstimateTemp) * 100;
            const eps = profitEstimateTemp / totalnumberofsharesEstimateTemp;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.profit_growth = profitGrowth.toFixed(0);
                    estimate.profit_margin = profitMargin.toFixed(0);
                    estimate.eps = eps.toFixed(3);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                profit: profitEstimateTemp,
                profit_growth: parseFloat(profitGrowth.toFixed(0)),
                profit_margin: parseFloat(profitMargin.toFixed(0)),
                eps: parseFloat(eps.toFixed(3))
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                profit: true,
                profit_growth: true,
                profit_margin: true,
                eps: true
            });

            this.saveStates = 'saved';
        },
        async setProfitMarginEps(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const profitGrowthEstimateTemp = parseFloat(est.profit_growth);
            const salesEstimateTemp = parseFloat(est.sales);
            const totalnumberofsharesEstimateTemp = parseFloat(act.totalnumberofshares);
            const profitActualTemp = parseFloat(base.profit);
            const profit = ((profitGrowthEstimateTemp / 100) + 1) * profitActualTemp;
            const profitMargin = (profit / salesEstimateTemp) * 100;
            const eps = profit / totalnumberofsharesEstimateTemp;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.profit = profit.toFixed(0);
                    estimate.profit_margin = profitMargin.toFixed(0);
                    estimate.eps = eps.toFixed(3);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                profit: parseFloat(profit.toFixed(0)),
                profit_growth: profitGrowthEstimateTemp,
                profit_margin: parseFloat(profitMargin.toFixed(0)),
                eps: parseFloat(eps.toFixed(3))
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                profit: true,
                profit_growth: true,
                profit_margin: true,
                eps: true
            });

            this.saveStates = 'saved';
        },
        async setProfitGrowthEps(est, act, base) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const profitMarginEstimateTemp = parseFloat(est.profit_margin);
            const salesEstimateTemp = parseFloat(est.sales);
            const totalnumberofsharesEstimateTemp = parseFloat(act.totalnumberofshares);
            const profitActualTemp = parseFloat(base.profit);
            const profit = salesEstimateTemp * ((profitMarginEstimateTemp / 100));
            const profitGrowth = ((profit - profitActualTemp) / profitActualTemp) * 100;
            const eps = profit / totalnumberofsharesEstimateTemp;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.profit = profit.toFixed(0);
                    estimate.profit_growth = profitGrowth.toFixed(0);
                    estimate.eps = eps.toFixed(3);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                profit: parseFloat(profit.toFixed(0)),
                profit_growth: parseFloat(profitGrowth.toFixed(0)),
                profit_margin: profitMarginEstimateTemp,
                eps: parseFloat(eps.toFixed(3))
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                profit: true,
                profit_growth: true,
                profit_margin: true,
                eps: true
            });

            this.saveStates = 'saved';
        },
        async setPs(est, act) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const salesEstimateTemp = parseFloat(est.sales);
            const epsEstimateTemp = parseFloat(est.eps);
            const peEstimateTemp = parseFloat(est.pe);
            const totalnumberofsharesEstimateTemp = parseFloat(act.totalnumberofshares);
            const price = (this.Q_or_FY === "Q") ? (epsEstimateTemp * peEstimateTemp) * 4 : epsEstimateTemp * peEstimateTemp;
            const ps = (this.Q_or_FY === "Q") ? (price / (salesEstimateTemp / totalnumberofsharesEstimateTemp)) / 4 : price / (salesEstimateTemp / totalnumberofsharesEstimateTemp);
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.ps = ps.toFixed(1);
                    estimate.target_price = price.toFixed(1);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                pe: peEstimateTemp,
                ps: parseFloat(ps.toFixed(1)),
                target_price: parseFloat(price.toFixed(1))
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                pe: true,
                ps: true,
                price: true,
                upside: true
            });

            this.saveStates = 'saved';
        },
        async setPe(est, act) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const epsEstimateTemp = parseFloat(est.eps);
            const psEstimateTemp = parseFloat(est.ps);
            const targetPriceEstimateTemp = parseFloat(est.target_price);
            const salesEstimateTemp = parseFloat(est.sales);
            const totalnumberofsharesEstimateTemp = parseFloat(act.totalnumberofshares);
            const price = (this.Q_or_FY === "Q") ? ((salesEstimateTemp / totalnumberofsharesEstimateTemp) * psEstimateTemp) * 4 : (salesEstimateTemp / totalnumberofsharesEstimateTemp) * psEstimateTemp;
            const pe = (this.Q_or_FY === "Q") ? (price / 4) / epsEstimateTemp : price / epsEstimateTemp;
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.pe = pe.toFixed(1);
                    estimate.target_price = price.toFixed(1);
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                pe: parseFloat(pe.toFixed(1)),
                ps: psEstimateTemp,
                target_price: parseFloat(price.toFixed(1))
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                pe: true,
                ps: true,
                price: true,
                upside: true
            });

            this.saveStates = 'saved';
        },
        async setComment(est, act) {
            // Open register popup if visitor
            if(this.user_id === 0) {
                this.setRegisterType('signup');
                this.setRegisterWindows(true);

                return;
            }

            const noteEstimateTemp = est.note.trim();
            const evEbit = ((parseFloat(act.totalnumberofshares) * parseFloat(act.price)) + (parseFloat(act.ibl) - parseFloat(act.cce))) / parseFloat(act.ebit);

            for(const estimate of this.estimationData) {
                if(estimate.period === est.period) {
                    estimate.totalnumberofshares = act.totalnumberofshares;
                    estimate.ev_ebit = evEbit.toFixed(0);
                }
            }

            await this.loadUserCompanyEstimates({
                user_id: this.user_id,
                company_id: this.company_id,
            });

            const checkIfAdded = this.getUserEtimates.filter((e) => e.period === est.period);

            // console.log(checkIfAdded);

            const insert = {
                user_company_est_id: checkIfAdded.length > 0 ? checkIfAdded[0].user_company_est_id : null,
                user_id: this.user_id,
                company_id: this.company_id,
                period: est.period,
                totalnumberofshares: parseFloat(act.totalnumberofshares),
                ev_ebit: parseFloat(evEbit.toFixed(0)),
                note: noteEstimateTemp
            };

            await this.upsertEstimate(insert);

            this.estimationData = this.buildEstimationData();

            this.setFlashFromGreyToYellow({
                period: est.period,
                note: true
            });

            this.saveStates = 'saved';
        },
        getBase(period) {
            const index = (this.estimationData.findIndex(o => o.period === period)) -1;

            // console.log(index);

            if(index <= -1) {
                // console.log(JSON.parse(JSON.stringify(this.getUserActualsQ_or_Fy)));
                return this.getUserActualsQ_or_Fy;
            }

            let filteredData = this.estimationData.filter((e) => {
                if(
                    e.period < period &&
                    (e.sales !== null ||
                    e.sales_growth !== null ||
                    e.ebit !== null ||
                    e.ebit_growth !== null ||
                    e.ebit_margin !== null ||
                    e.eps !== null ||
                    e.ev_ebit !== null ||
                    e.market_cap !== null ||
                    e.multiplier !== null ||
                    e.note !== null ||
                    e.pb !== null ||
                    e.pe !== null ||
                    e.ps !== null ||
                    e.profit !== null ||
                    e.profit_growth !== null ||
                    e.profit_margin !== null ||
                    e.target_price !== null ||
                    e.totalnumberofshares !== null)
                ) {
                    return e;
                }
            });

            if(filteredData.length === 0) {
                return this.getUserActualsQ_or_Fy;
            }

            filteredData = _.orderBy(filteredData, ['period'], ['desc']);

            // console.log(JSON.parse(JSON.stringify(filteredData)));

            return filteredData[0];
        },
        async upsertEstimate(insert) {
            if(insert.user_company_est_id === null) {
                await this.insertEstimate(insert);
            } else {
                await this.updateEstimate(insert);
            }
        },
        setShow(name, note, bol) {
            this.saveStates = 'saving';

            const inputElement = document.getElementById(name);
            const noteElement = document.getElementById(note);

            if(bol) {
                inputElement.style.display = 'block';
                noteElement.style.display = 'none';
            } else {
                inputElement.style.display = 'none';
                noteElement.style.display = 'block';
            }
        },
        setShowBlur(name, note, nameString, period, bol) {
            this.saveStates = '';

            const inputElement = document.getElementById(name);
            const noteElement = document.getElementById(note);

            if(bol) {
                inputElement.style.display = 'block';
                noteElement.style.display = 'none';
            } else {
                inputElement.style.display = 'none';
                noteElement.style.display = 'block';
            }

            if(this.originalString === '') {
                this.originalString = null;
            }

            for(const estimate of this.estimationData) {
                if(estimate.period === period) {
                    estimate[nameString] = this.originalString;
                }
            }

            // console.log(this.originalString);
        },
        setFlashFromGreyToYellow(obj) {
            const keys = Object.keys(obj);

            for(const key of keys) {
                this.flashObject[key] = obj[key];
            }

            // console.log(this.flashObject);

            setTimeout(() => {
                for(const key of keys) {
                    if(key !== 'period') {
                        this.flashObject[key] = false;
                    } else {
                        this.flashObject[key] = 'none';
                    }
                }

                // console.log(this.flashObject);
            }, 1050);
        },
        checkIfNeededSectionIsEmpty(data) {
            this.pinkMarker = data;
        }
    }
}
</script>

<style scoped>
>>> div {
    box-sizing: border-box !important;
}

>>> .estimates-placeholder > div > div > div:hover {
    border: 1px solid black !important;
}

.left-menu-button {
    height: 26px;
    background-color: #F5EDDA;
    /* color: #4077AB; */
    color: rgba(237, 188, 155, 1);
    width: 85px;
    /* border: 2px solid #4077AB; */
    border: 1px solid rgba(237, 188, 155, 1);
    border-radius: 4px 0 0 4px;
}

.right-menu-button {
    height: 26px;
    background-color: #ffffff;
    /* color: #4077AB; */
    color: #144B4E;
    width: 85px;
    /* border-right: 2px solid #4077AB;
    border-top: 2px solid #4077AB;
    border-bottom: 2px solid #4077AB; */
    border-right: 1px solid rgba(237, 188, 155, 1);
    border-top: 1px solid rgba(237, 188, 155, 1);
    border-bottom: 1px solid rgba(237, 188, 155, 1);
    border-radius: 0 4px 4px 0;
}

.menu-button-active {
    /* background-color: #4077AB; */
    background-color: rgba(237, 188, 155, 1);
    color: #ffffff;
    -color: #F5EDDA;
}

.left-menu-button:hover,
.right-menu-button:hover {
    /* background-color: grey; */
    opacity: 0.9;
    /* background-color: #E6E6E6; */
    /* color: #787878; */
}

.flash-from-grey-to-yellow {
    background-color: #f6f6f6;
    animation-name: grey-yellow-frames;
    animation-duration: 1s;
}

.flash-from-white-to-yellow {
    background-color: #ffffff;
    animation-name: white-yellow-frames;
    animation-duration: 1s;
}

.rotate-icon {
    animation: rotation 2s infinite linear;
}

@keyframes rotation {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(359deg);
    }
}

@keyframes grey-yellow-frames {
    from {background-color: #f6f6f6;}
    to {background-color: #f9f2dc;}
    from {background-color: #f9f2dc;}
    to {background-color: #f6f6f6;}
}

@keyframes white-yellow-frames {
    from {background-color: #ffffff;}
    to {background-color: #f9f2dc;}
    from {background-color: #f9f2dc;}
    to {background-color: #ffffff;}
}
</style>
